var React = require('react');

function LibrariesPlugins (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M19.11 4h-3.4a4.07 4.07 0 00-3.38 1.78A1.92 1.92 0 0012 6.87a1.92 1.92 0 00-.33-1.09A4.07 4.07 0 008.29 4h-3.4a.89.89 0 00-.89.89v12a.88.88 0 00.89.88h3.22A4.1 4.1 0 0111.77 20h.46a4.1 4.1 0 013.66-2.26h3.22a.88.88 0 00.89-.88v-12a.89.89 0 00-.89-.86zm-1 11.27a.62.62 0 01-.62.62h-2A2.85 2.85 0 0013 17.46h-.16V8.55a2.66 2.66 0 012.54-2.7h2.17a.62.62 0 01.62.62z","fill":"#001b35","key":1})]);
}

LibrariesPlugins.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = LibrariesPlugins;

LibrariesPlugins.default = LibrariesPlugins;
